"use client"

import { ReactNode, useState } from "react"
import SlideFromBottom from "@/components/SlideFromBottom"
import * as Styles from "@/components/Styles"

export default function QRCodeButton({
  sharingQRCodeSubtitle2,
  sharingQRCodeUrl,
  sharingQRCodeTitle,
  sharingQRCodeSubtitle,
}: {
  sharingQRCodeSubtitle2?: ReactNode
  sharingQRCodeUrl: string
  sharingQRCodeTitle: string
  sharingQRCodeSubtitle?: string
}) {
  const [isSlideOpen, setIsSlideOpen] = useState(false)

  return (
    <div>
      <SlideFromBottom
        closeSlide={() => setIsSlideOpen(false)}
        isOpen={isSlideOpen}
      >
        <div className={"flex flex-col items-center justify-center gap-4"}>
          <h1 className={`${Styles.headingTextClassName} text-center`}>
            {sharingQRCodeTitle}
          </h1>
          {sharingQRCodeSubtitle && (
            <div className={"text-xl font-[400] text-gray-400"}>
              {sharingQRCodeSubtitle}
            </div>
          )}
          {sharingQRCodeSubtitle2 && (
            <div className={"text-lg font-[400] text-gray-400"}>
              {sharingQRCodeSubtitle2}
            </div>
          )}
          <img
            data-testid={"share-qr-code"}
            width={311}
            height={311}
            src={sharingQRCodeUrl}
            alt={"Provider QR Code"}
          />
        </div>
      </SlideFromBottom>
      <button
        onClick={() => setIsSlideOpen(true)}
        className={
          "flex h-[40px] w-[40px] items-center justify-center rounded-full bg-[#e8e8e8]"
        }
      >
        <img width={22} height={23} src={"/qrcode.svg"} alt={"qr code"} />
      </button>
    </div>
  )
}
